import React, { FC, useState } from 'react';
import { TypeaheadRenderType, TypeaheadSelection, UitkTypeahead } from 'uitk-react-typeahead';
import { UitkButtonSize, UitkTertiaryButton } from 'uitk-react-button';
import { UitkIcon } from 'uitk-react-icons';
import { Icon } from 'graphql/__generated__/types';
import { ElasticSearchAdapter } from '../../search/elastic-search-adapter';
import { LunrSearchAdapter } from '../../search/lunr-search-adapter';

interface SearchTriggerMobile {
  searchHandler: (selection: TypeaheadSelection) => void;
  onInputChange: (e) => void;
  searchAdapter: ElasticSearchAdapter | LunrSearchAdapter;
  icon: Icon;
  label: string;
  typeaheadEmptyResultPlaceholder: string;
  typeaheadPlaceholder: string;
}

const SearchTriggerMobile: FC<SearchTriggerMobile> = (props) => {
  const {
    searchAdapter,
    searchHandler,
    icon,
    onInputChange,
    label,
    typeaheadEmptyResultPlaceholder,
    typeaheadPlaceholder,
  } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <UitkTypeahead
      id={icon.id}
      name={icon.title}
      icon={icon.token}
      label={label}
      onUpdate={searchHandler}
      onInputChange={onInputChange}
      customTrigger={{ showTypeahead: isOpen }}
      onDismiss={() => setIsOpen(false)}
      renderType={TypeaheadRenderType.ADAPTIVE}
      typeaheadEmptyResultPlaceholder={typeaheadEmptyResultPlaceholder}
      typeaheadPlaceholder={typeaheadPlaceholder}
      adapter={searchAdapter || ({} as ElasticSearchAdapter) || ({} as LunrSearchAdapter)}
      allowExactMatch
      hasClearButton
    >
      <UitkTertiaryButton
        onClick={() => {
          setIsOpen(true);
        }}
        size={UitkButtonSize.LARGE}
      >
        <UitkIcon name="search" theme="default" />
      </UitkTertiaryButton>
    </UitkTypeahead>
  );
};

export default SearchTriggerMobile;
